import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { findGetParameter, setCookie, getCookie } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { CatalogCard } from 'vpl.tas';
import { CheckboxItem } from 'vpl.tas';
import { showCatalogPreloader, hideCatalogPreloader  } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';



export const SearchCatalog = {
    components: {
        ItemEditBtns,
        CatalogCard,
        CheckboxItem
    },
    props: {
        structKey: [String, Number]
    },
    updated(){
        this.setFilterScripts();
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
    },
    mounted(){
        this.setFilterScripts();
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
/*
        let count = 0;
        for(let i in this.templateData.CatalogFilter.ITEMS){
            if(this.templateData.CatalogFilter.ITEMS[i].VALUES && Object.keys(this.templateData.CatalogFilter.ITEMS[i].VALUES).length){
                count++;
                this.openFilters[this.templateData.CatalogFilter.ITEMS[i].ID] = true;
            }
            if(count >= 2) break;
        }*/
        $(this.$el).find('.js-select').niceSelect();

        $(this.$el).find('select.js-sort-select').change(() => this.changeSort());
    },
    data() {
        return {
            filterElemCount: 0,
            openFilters: reactive({})
        }
    },
    methods: {
        findGetParameter: findGetParameter,
        getCookie: getCookie,
        setFilterScripts: function(){

            if( this.templateData.CatalogFilter && this.templateData.CatalogFilter.PRICE &&
                this.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE &&
                this.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE){

                let inputNum1 = $("#filterNum1"),
                    inputNum2 = $("#filterNum2"),
                    self = this,
                    minCur = +parseInt(self.templateData.CatalogFilter.PRICE.VALUES.MIN.HTML_VALUE ? self.templateData.CatalogFilter.PRICE.VALUES.MIN.HTML_VALUE : self.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE),
                    maxCur = +parseInt(self.templateData.CatalogFilter.PRICE.VALUES.MAX.HTML_VALUE ? self.templateData.CatalogFilter.PRICE.VALUES.MAX.HTML_VALUE : self.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE),
                    slider = document.getElementById("filterRangePrice");


                if(slider && $(slider).length){

                    if($(slider).hasClass('noUi-target')){
                        slider.noUiSlider.destroy();
                    }

                    noUiSlider.create(slider, {
                        start: [minCur, maxCur],
                        connect: true,
                        behaviour: "tap",
                        range: {
                            min: +parseInt(self.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE),
                            max: +parseInt(self.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE)
                        },
                        format: {
                            mark: ',',
                            decimals: 0,
                            thousand: ',',
                            to: function to(value) {
                                return Math.round(value);
                            },
                            from: function from(value) {
                                return value;
                            }
                        }
                    });

                    slider.noUiSlider.on("update", function (values, handle) {
                        let value = String(Math.round(values[handle])).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ");

                        if (handle) {
                            inputNum2.val(value);
                        } else {
                            inputNum1.val(value);
                        }
                    });

                    slider.noUiSlider.on('change', function(){
                        self.setFilter();
                    });

                    inputNum1.unbind( "keyup" );
                    inputNum1.keyup(function () {
                        slider.noUiSlider.set([Number($(this).val().replace(" ", "")), null]);
                    });

                    inputNum2.unbind( "keyup" );
                    inputNum2.keyup(function () {
                        slider.noUiSlider.set([null, Number($(this).val().replace(" ", ""))]);
                    });
                }
            }



        },
        setFilter(){
            let self = this;
            if(this.filterTimeout){
                clearTimeout(this.filterTimeout);
            }
            this.filterTimeout = setTimeout(function(){

                let searchParams = new URLSearchParams();

                searchParams.set('q', self.findGetParameter('q'));

                $('.js-filter').find('input').each(function(){
                    if($(this).prop('type') == 'text'){
                        let dataVal = false;

                        if($(this).hasClass('js-price-min')){
                            dataVal = +parseInt(self.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE);
                        }else{
                            dataVal = +parseInt(self.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE);
                        }

                        if(!dataVal || parseInt(dataVal) != parseInt($(this).val().replace(/\s/g, ''))){
                            searchParams.set($(this).prop('name'), $(this).val().replace(/\s/g, ''));
                        }
                    }

                    if($(this).prop('type') == 'checkbox' && $(this).prop('checked')){
                        searchParams.set($(this).prop('name'), $(this).val());
                    }
                });
                searchParams.set('ajax', 'y');

                showCatalogPreloader();

                BX.ajax.get(
                    window.location.pathname + '?' + searchParams.toString().replace(/&amp;/g, "&"),
                    function(response){
                        response = BX.parseJSON(response);

                        if(response.FILTER_URL){

                            let url = response.FILTER_URL.replace(/&amp;/g, "&");

                            $.ajax({
                                url: url + '&get_json=Y',
                                method: 'GET',
                                success: (itemsResponse) => {

                                    window.history.pushState( url , self.title , url );

                                    itemsResponse = JSON.parse(itemsResponse);
                                    self.struct[self.structKey].componentData.ITEMS = itemsResponse.struct[self.structKey].componentData.ITEMS;
                                    self.struct[self.structKey].componentData.PAGIN = itemsResponse.struct[self.structKey].componentData.PAGIN;

                                    self.templateData.CatalogFilter = itemsResponse.templateData.CatalogFilter;

                                    let rootNode = $(self.$el);
                                    for( let i in itemsResponse.templateData.CatalogFilter.ITEMS){
                                        let item = itemsResponse.templateData.CatalogFilter.ITEMS[i];
                                        for(let j in item.VALUES){
                                            if(item.VALUES[j].DISABLED){
                                                rootNode.find('#' + item.VALUES[j].CONTROL_ID).parent().addClass('disabled');
                                            }else{
                                                rootNode.find('#' + item.VALUES[j].CONTROL_ID).parent().removeClass('disabled');
                                            }
                                        }
                                    }

                                    hideCatalogPreloader();
                                }
                            });
                        }else{
                            hideCatalogPreloader();
                        }

                        self.filterElemCount = response.ELEMENT_COUNT;
                    }
                );

            }, 500);
        },
        clearFilter(){
            showCatalogPreloader();
            VplRouter(this.templateData.CatalogFilter.DEL_FILTER, false, false, false);
        },
        hideFilter(e){
            e.preventDefault();
            $('.js-filter-mob').removeClass('is-open');
            $('body').removeClass('modal-open');
            $('.js-filter-link').removeClass('is-active');
            $('body').removeClass('filter-open');
        },
        processFilterItemView(event, id){

            this.openFilters[id] = !this.openFilters[id];

            let link = $(event.target);
            if (link.parents('.js-filter-item').hasClass('is-open')) {
                link.parents('.js-filter-item').removeClass('is-open');
                link.parents('.js-filter-item').find('.js-filter-list-wp').slideUp();
            } else {
                link.parents('.js-filter-item').addClass('is-open');
                link.parents('.js-filter-item').find('.js-filter-list-wp').slideDown();
            }
        },
        openFilter(e) {
            e.preventDefault();
            let link = $('.js-filter-link');
            if ($(window).width() < 992) {
              if (!link.hasClass('is-active')) {
                link.addClass('is-active');
                $('.js-filter-mob').addClass('is-open');
                $('body').addClass('modal-open');
                $('body').addClass('filter-open');
              } else {
                link.removeClass('is-active');
                $('.js-filter-mob').removeClass('is-open');
                $('body').removeClass('modal-open');
                $('body').removeClass('filter-open');
              }
            }
        },
        lazyLoad(link ,append = true){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.struct[this.structKey].componentData.ITEMS = [...this.items, ...response.struct[this.structKey].componentData.ITEMS];
                    }else{
                        this.struct[this.structKey].componentData.ITEMS = response.struct[this.structKey].componentData.ITEMS;
                    }
                    this.struct[this.structKey].componentData.PAGIN = response.struct[this.structKey].componentData.PAGIN;

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(this.$el).offset().top - 70
                    }, 500);
                }
            });
        },
        setCardView(e) {
            e.preventDefault();

            setCookie("catalogView", "card", 30);

            $('.js-view-line').removeClass('is-active');
            $('.js-view-card')
                .addClass('is-active')
                .parents('.js-catalog').find('.js-catalog-list').removeClass('line-view');

        },
        setLineView(e) {
            e.preventDefault();

            setCookie("catalogView", "wide", 30);

            $('.js-view-card').removeClass('is-active');
            $('.js-view-line')
                .addClass('is-active')
                .parents('.js-catalog').find('.js-catalog-list').addClass('line-view');

        },
        changeSort(){

            let data = $(this.$el).find('select.js-sort-select').val().split("/");
            setCookie("sort", data[0], 30);
            setCookie("sort_dir", data[1], 30);

            let arRoute = window.location.href.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            $.ajax({
                url: arRoute[0] + '?' + params,
                method: "POST",
                data: { sort: data[0], sort_dir: data[1] },
                success:  (response) => {
                    response = JSON.parse(response);
                    this.struct[this.structKey].componentData.ITEMS = response.struct[this.structKey].componentData.ITEMS;
                    this.struct[this.structKey].componentData.PAGIN = response.struct[this.structKey].componentData.PAGIN;
                },
            });
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'struct', 'title'])
    },
    template: `
<section class="search-result__page">
    <div class="container">
        <div class="catalog">
            <div class="catalog__wp js-catalog">


                <div class="catalog__leftside js-filter-mob">
                    <div class="container">
                        <div class="filter js-filter">
                            <form action=""  v-if="this.templateData.CatalogFilter">
                                <div class="filter-head">
                                    <div class="filter-head-title">Фильтр</div>
                                    <a href="#" class="filter-head-close js-filter-close">
                                        <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                                    </a>
                                </div>

                                <div v-if="this.filterElemCount > 0" class="filter__entry">
                                    <div class="filter__entry-count">
                                        Выбрано:
                                        <span class="filter__entry-count-num">{{ this.filterElemCount }}</span>
                                    </div>
                                    <button @click.prevent="clearFilter()" type="button" class="filter__entry-clear js-filter-clear">Очистить фильтр</button>
                                </div>

                                <div class="filter__item-wp">


                                    <div v-if="this.templateData.CatalogFilter.PRICE && this.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE && this.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE" class="filter__item filter__item--range js-filter-item is-open">
                                        <div class="filter__item-entry js-filter-entry">
                                            <div class="filter__item-entry-title">Цена, ₽</div>
                                            <div class="filter__item-entry-arrow">
                                                <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                                            </div>
                                        </div>
                                        <div class="filter__item-list js-filter-list-wp">
                                            <div class="filter__item-range-inputs">
                                                <div class="filter__item-range-inputs-container">
                                                    <input type="text"
                                                        aria-label="Цена товара"
                                                        title="Цена товара"
                                                        @input="setFilter()"
                                                        id="filterNum1"
                                                        :name="this.templateData.CatalogFilter.PRICE.VALUES.MIN.CONTROL_NAME"
                                                        :value="parseInt(this.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE)"
                                                        :data-value="parseInt(this.templateData.CatalogFilter.PRICE.VALUES.MIN.VALUE)"
                                                        class="filter__item-range-prev js-filter-prev js-price-min">
                                                </div>
                                                <div class="filter__item-range-inputs-container">
                                                    <input type="text"
                                                        aria-label="Цена товара"
                                                        title="Цена товара"
                                                        @input="setFilter()"
                                                        id="filterNum2"
                                                        :name="this.templateData.CatalogFilter.PRICE.VALUES.MAX.CONTROL_NAME"
                                                        :value="parseInt(this.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE)"
                                                        :data-value="parseInt(this.templateData.CatalogFilter.PRICE.VALUES.MAX.VALUE)"
                                                        class="filter__item-range-next js-filter-next js-price-max">
                                                </div>
                                            </div>
                                            <div class="catalog__filter-item-range-dragger js-filter-dragger" id="filterRangePrice"></div>
                                        </div>
                                    </div>

                                    <template v-for="item, key in this.templateData.CatalogFilter.ITEMS" :key="item.CODE" >
                                        <CheckboxItem :item="item" @process-filter-item-view="processFilterItemView" @set-filter="setFilter" :open="openFilters[item.ID]" />
                                    </template>

                                </div>
                                <a href="#" @click.prevent="hideFilter($event)" class="btn btn--redfull filter__mobile-show">Показать</a>
                            </form>
                        </div>
                    </div>
                </div>


                <div class="catalog__rightside">
                    <div class="catalog__rightside-top">
                        <div class="catalog__rightside-inner">
                            <div class="sort__select-wp">
                                <select name="" id="" class="sort__select js-select js-sort-select" @change="changeSort($event)">
                                    <option :selected="(!this.getCookie('sort') || this.getCookie('sort') == 'DEFAULT')" value="DEFAULT/DEFAULT">Сортировка по умолчанию</option>
                                    <option :selected="(this.getCookie('sort') == 'PRICE' && this.getCookie('sort_dir') == 'ASC')" value="PRICE/ASC">Сначала дешевле</option>
                                    <option :selected="(this.getCookie('sort') == 'PRICE' && this.getCookie('sort_dir') == 'DESC')" value="PRICE/DESC">Сначала дороже</option>
                                    <option :selected="(this.getCookie('sort') == 'created_date')" value="created_date/DESC">По новизне</option>
                                    <option :selected="(this.getCookie('sort') == 'shows')" value="shows/DESC">По популярности</option>
                                </select>
                            </div>
                            <div class="catalog__items-view">
                                <a href="#" class="catalog__items-view-item js-view-card" @click="setCardView($event)" :class="{'is-active': !this.getCookie('catalogView') || this.getCookie('catalogView') == 'card'}">
                                    <svg class="icon icon-view-card"><use xlink:href="#icon-view-card"></use></svg>
                                </a>
                                <a href="#" class="catalog__items-view-item js-view-line" @click="setLineView($event)" :class="{'is-active': this.getCookie('catalogView') == 'wide'}">
                                    <svg class="icon icon-view-line"><use xlink:href="#icon-view-line"></use></svg>
                                </a>
                            </div>
                        </div>
                        <a href="#" @click="openFilter($event)" class="catalog__filter-mob js-filter-link">Фильтр</a>
                    </div>
                    <div class="catalog__items-list js-catalog-list" v-if="this.struct[this.structKey].componentData.ITEMS" :class="{'line-view': this.getCookie('catalogView') == 'wide'}">
                        <template v-for="item in this.struct[this.structKey].componentData.ITEMS">
                            <CatalogCard :item="item"/>
                        </template>
                        <div class="content-nav" v-if="this.struct[this.structKey].componentData.PAGIN">
                            <ul class="content-nav__list">
                                <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                                    <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                                        <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                            <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                                        </a>
                                    </li>
                                    <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                                    <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                                    <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                                        <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                                        </a>
                                    </li>
                                </template>
                            </ul>

                            <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                                <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn">Показать ещё</a>
                            </template>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</section>
    `
}